import React from 'react'
import SubmitButton from '../atoms/buttons/SubmitButton'

const SearchBar = ({ keyword, onChange, onSubmit, className, dataSource, isLoading, minLength }) => {
  return (
    <form
      className='search-bar-form'
      style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, marginRight: '20px' }}
      onSubmit={onSubmit}
    >
      <input
        className={'min-h-[38px] rounded border border-midnight-black-40 pl-10 max-w-[400px] [@media(max-width:992px)]:max-w-none ' + className}
        style={{ flex: 1, width: 'auto', marginRight: 0, marginBottom: 0 }}
        value={keyword}
        placeholder='Search listings'
        onChange={onChange}
        data-source={dataSource}
        minLength={minLength}
      />
      <SubmitButton
        className='vsd-button__filled search-bar-button vsd-button__extra-small inline-flex justify-center'
        buttonValue={isLoading ? 'Searching…' : 'Search'}
        disabled={isLoading}
      />
    </form>
  )
}

export default SearchBar
